module.exports = __webpack_public_path__ + "static/media/stephen-taylor-data-logo-main.cfb3b697.svg";